export const labels = {
  activityTitle: 'Activity Title',
  inspectionType: 'Inspection Type',
  information: 'Information',
  gateCode: 'Gate Code',
  avoperator: 'A/V Operator',
  trades: 'Trades',
  activityContact: 'Activity Contact',
  inspectionDate: 'Inspection Date',
  activityStatus: 'Activity Status',
  period: 'Time',
  inspector: 'Inspector',
  followUp: 'Follow-up date',
  assignedTo: 'Assigned to',
  emergency: 'Emergency',
  isCompleted: 'Completed',
  activityContactCheckbox: 'Activity Contact',
  jurisdictionContacts: 'Jurisdiction',
  projectContacts: 'Project Contacts',
  additionalContacts: 'More Contacts',
  cellPhone: 'Cell Phone',
  phoneNumber: 'Phone Number',
  dateCreated: 'Date Created',
  createdBy: 'Created By',
  dateCompleted: 'Date Completed',
  completedBy: 'Completed By',
  gateCode: 'Gate Code',
  approvedPlans: 'Approved Plans',
};

export const periodData = [
  { name: 'AM', id: 0 },
  { name: 'PM', id: 1 },
  { name: 'Any', id: 2 },
];

export const DONTSEARCH = 'dontsearchanyrecord';

export const accountingEmails = {
  Naples: 'nplaccounting@elitepermits.com',
  Sarasota: 'sstaccounting@elitepermits.com',
  'Fort Myers': 'lccaccounting@elitepermits.com',
};

// Statuses that need Information text before the inspection can be saved.
export const INFORMATION_REQUIRED_STATUSES = ['Partial Pass', 'Cancelled', 'Failed'];

// Every result a visit can end in. None may be saved without the inspection
// report. This used to be the three statuses above, which let Pass and Not
// Applicable complete with nothing attached. Scheduled is left out: the visit
// has not happened yet. The server enforces the same list
// (inspections/constants.py REPORT_REQUIRED_STATUSES).
export const REPORT_REQUIRED_STATUSES = ['Pass', 'Partial Pass', 'Failed', 'Cancelled', 'Not Applicable'];

// What a created report printed that the user can still change afterwards. A
// report made as Failed and then saved as Pass put a Failed report on a passed
// inspection, so a report only counts while these still match.
export const reportFingerprint = (statusName?: string, information?: string | null): string =>
  `${statusName || ''}|${(information || '').trim()}`;
